export const initialState = {
  data: [],
  errors: undefined,
  loading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'mediumFetch': {
      return { ...state, loading: true };
    }
    case 'mediumFetchSuccess': {
      return { ...state, loading: false, data: action.payload };
    }
    case 'mediumFetchError': {
      return { ...state, loading: true, errors: action.payload };
    }
    default: {
      return state;
    }
  }
}

export { reducer as mediumReducer }